<section [class.disabled]="disabled">
    <header class="section-header">
        <div class="section-title">
            <h3 [id]="tableId + '-title'">{{ title }}</h3>
            <span class="item-count" data-uiid="linked-item-table-count">{{ items.length }}</span>
        </div>
        @if (canLink) {
            <cerrix-button
                buttonType="secondary"
                secondaryColor="outlined-gray"
                icon="link"
                iconPosition="right"
                [text]="'common.link' | t : {} : rootScope"
                [disabled]="disabled"
                (click)="linkItems.emit()"
            />
        }
    </header>
    <table [attr.aria-labelledby]="tableId + '-title'">
        <colgroup>
            @for (column of templates.columns; track column.key) {
                <col [style.width]="column.width" />
            }
            <col class="actions-column" />
        </colgroup>
        <thead>
            <tr>
                @for (column of templates.columns; track column.key) {
                    <th scope="col">{{ column.header }}</th>
                }
                <th scope="col">
                    <span class="visually-hidden">{{ 'actions' | t }}</span>
                </th>
            </tr>
        </thead>
        @for (item of visibleItems; track templates.itemKey(item); let index = $index) {
            <tbody [class.expanded]="expandedItem() === item">
                <tr
                    class="item-row"
                    [attr.data-uiid]="'linked-item-row-' + templates.itemKey(item)"
                    [class.expandable]="expandable"
                    [attr.tabindex]="expandable ? -1 : null"
                    [attr.aria-expanded]="expandable ? expandedItem() === item : null"
                    [attr.aria-controls]="expandedItem() === item ? tableId + '-details-' + index : null"
                    (click)="onRowInteraction(item, $event)"
                    (keydown.enter)="onRowInteraction(item, $event)"
                    (keydown.space)="onRowInteraction(item, $event)"
                >
                    <ng-container
                        [ngTemplateOutlet]="templates.overviewRow"
                        [ngTemplateOutletContext]="{ $implicit: item, disabled: disabled }"
                    />
                    <td class="row-actions">
                        @if (expandable) {
                            <button
                                class="expand-toggle visually-hidden"
                                type="button"
                                [attr.aria-label]="(expandedItem() === item ? 'collapseDetails' : 'expandDetails') | t"
                                [attr.aria-expanded]="expandedItem() === item"
                                (click)="toggleDetails(item)"
                            >
                                {{ (expandedItem() === item ? 'collapseDetails' : 'expandDetails') | t }}
                            </button>
                        }
                        <div data-linked-item-table-action [attr.inert]="disabled ? '' : null">
                            <app-linked-item-table-row-actions
                                [itemLabel]="templates.itemKey(item)"
                                [disabled]="disabled"
                                [canUnlink]="canLink && item.canUnlink"
                                (open)="openItem.emit(item)"
                                (unlink)="requestUnlink(item)"
                            />
                            @if (rowActions) {
                                <ng-container
                                    [ngTemplateOutlet]="rowActions"
                                    [ngTemplateOutletContext]="{ $implicit: item, disabled: disabled }"
                                />
                            }
                        </div>
                    </td>
                </tr>
                @if (expandedItem() === item) {
                    <tr>
                        <td class="details" [attr.colspan]="columnCount" [id]="tableId + '-details-' + index">
                            @let state = detailState();
                            @switch (state.status) {
                                @case ('loading') {
                                    <p role="status">{{ 'loadingDetails' | t }}</p>
                                }
                                @case ('error') {
                                    <div role="alert">
                                        <p>{{ 'detailsError' | t }}</p>
                                        <button type="button" (click)="retryDetails()">
                                            {{ 'retry' | t }}
                                        </button>
                                    </div>
                                }
                                @case ('loaded') {
                                    <ng-container
                                        [ngTemplateOutlet]="templates.detailRow"
                                        [ngTemplateOutletContext]="{ $implicit: item, details: state.data, disabled: disabled }"
                                    />
                                }
                            }
                        </td>
                    </tr>
                }
            </tbody>
        } @empty {
            <tbody>
                <tr>
                    <td class="empty-state" [attr.colspan]="columnCount">
                        {{ 'empty' | t }}
                    </td>
                </tr>
            </tbody>
        }
    </table>
    @if (showFooter) {
        <footer class="paging-footer">
            <span class="range-summary">
                {{ 'range' | t: { first: firstItem, last: lastItem, total: items.length } }}
            </span>
            <app-cerrix-pagination
                [totalItems]="items.length"
                [itemsPerPage]="pageSize()"
                [limit]="5"
                [currentPage]="currentPage()"
                (currentPageChange)="changePage($event)"
            />
            <label class="page-size">
                {{ 'show' | t }}
                <select #size [value]="pageSize()" (change)="changePageSize(size.value)">
                    @for (option of pageSizes; track option) {
                        <option [value]="option">{{ option }}</option>
                    }
                </select>
                {{ 'entries' | t }}
            </label>
        </footer>
    }
    @if (unlinkConfirmation) {
        <cerrix-confirm-dialog
            [name]="unlinkConfirmationDialogName"
            dataUiid="linked-item-table-unlink-confirmation"
            icon="warning"
            [title]="unlinkConfirmation.title"
            [description]="unlinkConfirmation.description"
            [cancelText]="'unlinkConfirmation.cancel' | t"
            [confirmText]="'unlinkConfirmation.confirm' | t"
            (cancel)="closeUnlinkConfirmation()"
            (confirm)="confirmUnlink()"
        />
    }
</section>
